import axios from "axios";
import { eventBus } from "@/main";

const moduleBranch = {
  namespaced: true,
  state: {
    branchInfo: null,
    branchPath: "",
    hasSubscribed: false,
    isFileStorageExpired: true,
  },
  mutations: {
    setBranchInfo(state, data) {
      if (data && data.clinic) {
        state.branchInfo = data;
        state.branchPath = `${data.clinic.code}/${data.code}`;
        state.hasSubscribed = Boolean(data.fileStoreExpiration);

        const currentDate = new Date();
        const givenDate = new Date(data.fileStoreExpiration);
        givenDate < currentDate
          ? (state.isFileStorageExpired = true)
          : (state.isFileStorageExpired = false);
      } else {
        state.branchInfo = null;
        state.branchPath = "";
        state.hasSubscribed = false;
        state.isFileStorageExpired = true;
      }
    },
  },
  actions: {
    setBranchInfo({ commit }, data) {
      commit("setBranchInfo", data);
    },
    updateBranchConfig({ commit, dispatch }, payload) {
      return axios
        .put(
          `/api/branch/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.data
        )
        .then((res) => {
          dispatch("moduleUser/setStateBranchInfo", res.data, { root: true });
          return res;
        })
        .catch((err) => {
          //// Automatic error handling via interceptor
          throw err;
        });
    },
    fetchBranchByUrl({ commit, dispatch }, payload) {
      return axios
        .get(`/api/branch/${payload.clinicUrl}/${payload.branchUrl}`)
        .then((res) => {
          commit("setBranchInfo", res.data);
          // Also update moduleUser.branchInfo so other components get updated data
          dispatch("moduleUser/setStateBranchInfo", res.data, { root: true });
          return res;
        })
        .catch((err) => {
          console.error(err);
          // Automatic error handling via interceptor
          throw err;
        });
    },
    checkBranchMember({ commit }, payload) {
      return axios
        .get(
          `/api/branchMember/unAuthorizeUser/${payload.clinicUrl}/${payload.branchUrl}/${payload.email}`,
          { skipGlobalErrorHandler: true }
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
       
          throw err;
        });
    },
    fetchBranchMember({ commit }, payload) {
      return axios
        .get(`/api/branchMember/${payload.clinicUrl}/${payload.branchUrl}`)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    fetchBranchMemberIncludeDeleted({ commit }, payload) {
      return axios
        .get(`/api/branchMember/${payload.clinicUrl}/${payload.branchUrl}`, {
          params: { activeMembersOnly: false },
        })
        .then((res) => {
          return res;
        })
        .catch((err) => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    createBranchMember({ commit }, payload) {
      return axios
        .post(
          `/api/branchMember/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.member
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    updateBranchMember({ commit }, payload) {
      return axios
        .put(
          `/api/branchMember/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.member
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    deleteBranchMember({ commit }, payload) {
      return axios
        .delete(
          `/api/branchMember/${payload.clinicUrl}/${payload.branchUrl}/${payload.uid}`
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    createAndUpdateDooctorWorkingHours({ commit }, payload) {
      return axios
        .post(
          `/api/branchMember/doctorWorkingHour/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            branchMemberId: payload.branchMemberId,
            doctorWorkingHours: payload.doctorWorkingHours
          }
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    // Room Management Actions
    fetchRoomList({ commit }, payload) {
      return axios
        .get(`/api/room/${payload.clinicUrl}/${payload.branchUrl}`)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
    createRoom({ commit }, payload) {
      return axios
        .post(
          `/api/room/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.room
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
    updateRoom({ commit }, payload) {
      return axios
        .put(
          `/api/room/${payload.clinicUrl}/${payload.branchUrl}/${payload.roomId}`,
          payload.room
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
    deleteRoom({ commit }, payload) {
      return axios
        .delete(
          `/api/room/${payload.clinicUrl}/${payload.branchUrl}/${payload.roomId}`
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
    // Receipt Payment Method Management Actions
    fetchReceiptPaymentList({ commit }, payload) {
      return axios
        .get(`/api/master/receiptPayment/${payload.clinicUrl}/${payload.branchUrl}`)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
    createReceiptPayment({ commit }, payload) {
      return axios
        .post(
          `/api/master/receiptPayment/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.receiptPayment
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
    updateReceiptPayment({ commit }, payload) {
      return axios
        .put(
          `/api/master/receiptPayment/${payload.clinicUrl}/${payload.branchUrl}/${payload.receiptPaymentId}`,
          payload.receiptPayment
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
    deleteReceiptPayment({ commit }, payload) {
      return axios
        .delete(
          `/api/master/receiptPayment/${payload.clinicUrl}/${payload.branchUrl}/${payload.receiptPaymentId}`
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
    fetchPaymentCategories({ commit }, payload) {
      return axios
        .get(`/api/master/mReceiptPaymentCate/${payload.clinicUrl}/${payload.branchUrl}`)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
  },
  getters: {
    getBranchInfo: (state) => {
      return state.branchInfo;
    },
    getClinicInfo: (state) => {
      if (state.branchInfo && state.branchInfo.clinic) {
        return state.branchInfo.clinic;
      } else {
        return null;
      }
    },
    getRoomList: (state) => {
      if (state.branchInfo && state.branchInfo.rooms) {
        return state.branchInfo.rooms;
      } else {
        return [];
      }
    },
    getRoomListBy: (state, getters) => (value, key) => {
      return getters.findBy(state.branchInfo.rooms, value, key, {
        value: null,
        label: "-",
      });
    },
    getAuthorization: (state) => {
      if (state.branchInfo && state.branchInfo.auth) {
        return state.branchInfo.auth;
      } else {
        return { authId: 0 };
      }
    },
    getBranchPath: (state) => {
      return state.branchPath;
    },
    isFileStorageExpired: (state) => {
      return state.isFileStorageExpired;
    },
    hasSubscribed: (state) => {
      return state.hasSubscribed;
    },
  },
};
export default moduleBranch;
